module.exports = __webpack_public_path__ + "img/logo_inverted.f06317a6.svg";